import React, { Component } from 'react';
import AirTabbedModal from '../../../../../../common/components/AirTabbedModal';
import { inject, observer } from 'mobx-react';
import { Pagination, Spin, Table } from 'antd';

import './HistoryModal.css';

@inject('translationsStore')
@observer
export default class HistoryModal extends Component {
  render() {
    const { translationsStore, visible, onOk, onCancel, onTableChange, title } = this.props;
    let { columns, dataSource, pagination } = this.props;
    dataSource = dataSource.map((data, index) => ({ ...data, key: index }));

    const start = pagination.pageSize * (pagination.current - 1) + 1;
    const end = Math.min(pagination.total, start + pagination.pageSize - 1);
    const paginationText = `${start}-${end} ${translationsStore.translate('of')} ${pagination.total}`;

    return (
      <AirTabbedModal
        className="HistoryModal"
        tabs={[
          {
            key: 'list',
            title: title,
            render: (
              <div style={{ marginTop: 30 }}>
                <Spin spinning={false}>
                  <div className="HistoryModalPaneFrame">
                    <Table columns={columns} dataSource={dataSource} pagination={false} onChange={(...params) => onTableChange(...params)} />
                  </div>
                  {pagination !== false && pagination.total > pagination.pageSize && (
                    <div className="HistoryModalPagination">
                      <div>{paginationText}</div>
                      <Pagination {...pagination} />
                    </div>
                  )}
                </Spin>
              </div>
            )
          }
        ]}
        visible={visible}
        width={500}
        onOk={onOk}
        onCancel={onCancel}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/LockUnlockPanel/HistoryModal/HistoryModal.js